<h1 mat-dialog-title>Edit Pre Filters</h1>
<div mat-dialog-content>
  <pre-filter-selection #preFilterSelection [preFilterId]="data.preFilterId"></pre-filter-selection>
</div>
<div mat-dialog-actions>
  <button mat-raised-button
          class="piButton"
          (click)="onConfirmClick()"
          cdkFocusInitial>
    Confirm
  </button>
  <button mat-raised-button class="piButton" (click)="onCancelClick()">
    Cancel
  </button>
</div>
